import { CustomTheme } from '../../../../common/types/settings';

const customThemeSet = new Set<string>([CustomTheme.LIGHT, CustomTheme.DARK]);

export const isCustomTheme = (theme: string | null): theme is CustomTheme => {
    return theme !== null && customThemeSet.has(theme);
};
